import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { FeatureFlagsService } from '../../services/feature-flags/feature-flags.service';
import { BaseRouteEnum } from '../../enums/route/base-route.enum';
@Injectable({
  providedIn: 'root'
})
export class QuickQuoteCheckGuard implements CanActivate {
  constructor(private router: Router, private featureFlagsService: FeatureFlagsService) {}

  canActivate(): boolean {
    if (!this.featureFlagsService.isQuickQuoteEnabled()) {
      this.router.navigate([BaseRouteEnum.EMPTY]);
      return false;
    }
    return true;
  }
}
